import { useEffect, useState } from "react";
import { Download } from "lucide-react";
import { toast } from "sonner";

export default function InstallButton({ className = "" }) {
  const [prompt, setPrompt] = useState(null);
  const [installed, setInstalled] = useState(
    typeof window !== "undefined" && window.matchMedia("(display-mode: standalone)").matches
  );

  useEffect(() => {
    const onPrompt = (e) => { e.preventDefault(); setPrompt(e); };
    const onInstalled = () => { setInstalled(true); setPrompt(null); toast.success("Aplikasi terpasang!"); };
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", onInstalled);
    return () => {
      window.removeEventListener("beforeinstallprompt", onPrompt);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  if (installed) return null;

  const install = async () => {
    if (!prompt) {
      toast.message("Buka menu browser lalu pilih 'Tambahkan ke Layar Utama'");
      return;
    }
    prompt.prompt();
    await prompt.userChoice;
    setPrompt(null);
  };

  return (
    <button data-testid="install-app-button" onClick={install}
      className={`nb-btn flex items-center justify-center gap-2 ${className}`}
      style={{ background: "var(--primary)" }}>
      <Download className="w-4 h-4" strokeWidth={2.5} /> Install
    </button>
  );
}
